import { fetchAcceptancesList } from '@/fsd/pages/acceptances/api/fetchAcceptancesList/fetchAcceptancesList';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { getPurchaseItemLocation } from './getPurchaseItemLocation';
import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { NavigateFunction } from 'react-router-dom';

interface IParams {
  navigate: NavigateFunction;
}

export const moveToAcceptanceItem = async ({ navigate }: IParams) => {

  const result = await queryClient.fetchQuery({
    queryKey: ['acceptancesList'],
    queryFn: async () =>
      await fetchAcceptancesList({
        metaData: { current_page: 1, page_size: 1 },
      }),
  });

  const itemId = result?.data[0].id;


  const purchaseItemLocation = getPurchaseItemLocation(
    routes.acceptanceItem.path,
    itemId
  );

  console.log(
    'moveToAcceptanceItem',
    'purchaseItemLocation',
    purchaseItemLocation
  );

  navigate(purchaseItemLocation);
};
